import { LayoutContent } from "@/modules/main/LayoutContent.tsx";
import { showOnlyContentAtom } from "@/modules/main/MainLayout.store.ts";
import { MobileTopNav } from "@/modules/main/TopNav.tsx";
import { initSections } from "@/modules/main/sidebar/Sidebar.sections.tsx";
import { useAtomValue } from "jotai/react";
import type { ReactNode } from "react";

export function MobileLayout({ children }: { children?: ReactNode }) {
    const showOnlyContent = useAtomValue(showOnlyContentAtom);
    if (showOnlyContent) {
        return children;
    }

    initSections();

    return (
        <>
            <MobileTopNav />
            <LayoutContent>{children}</LayoutContent>
        </>
    );
}
